// export const getAPIBaseURL = () => "http://localhost:3000/v2";
export const getAPIBaseURL = () => "https://illnessrx-backend.illnessrx.com/v2"; //process.env.REACT_APP_API_BASE_URL
// export const getAPIBaseURL = () => "http://illnessrxprod-env.eba-d2wjuafe.us-east-2.elasticbeanstalk.com/v2"; //process.env.REACT_APP_API_BASE_URL_test_url

export const getSocialSocketURL = () => {
  const base = getAPIBaseURL();
  return base
    .replace(/^http/, "ws")
    .replace(/\/v2\/?$/, "")
    .concat("/ws/social");
};
